import { Helpdesk } from './Helpdesk'
import Formtopia from 'formtopia/react-admin/resources'

export default class Services {
  static Formtopia = Formtopia
  static Helpdesk = Helpdesk
}
